import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import HPSInformation from '../../components/EnrollForm/HPSInformation';
import BreadCrumbs from '../../components/Breadcrumbs';
import { withRouter } from 'react-router-dom';

const SignUp = (props) => {
  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      gtmTrackId = 'track-142 gtm-track-57';
      break;
    case 'fruzaqla':
      gtmTrackId = 'track-142 gtm-track-57';
      break;
    case 'iclusig':
      gtmTrackId = 'track-142 gtm-track-58';
      break;
    case 'ninlaro':
      gtmTrackId = 'track-142 gtm-track-59';
      break;
    case 'mimrylo':
      gtmTrackId = 'track-142 gtm-track-60';
      break;
    default:
      gtmTrackId = '';
  }

  return (
    <div className="sign-up full-width">
      <BreadCrumbs activeIndex={ 1 }/>
      <div className="wrapper">
        <Header as="h1">Now take a moment to fill out your patient’s personal information</Header>

        <HPSInformation
          onSubmit={ props.onSubmit }
          environment={ props.environment }
          formType={ props.formType }
          submitTrackId={ gtmTrackId }
          signUpTreatment={ props.signUpTreatment }
          updateSignTreatment={ props.updateSignTreatment }
        />
      </div>
    </div>
  );
};

SignUp.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
};

export default withRouter(SignUp);
